import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="flex h-svh max-w-none items-center justify-center">
        <Loader />
      </div>
    );
  }
  return (
    <div className="flex h-svh items-center justify-center bg-background">
      <div className="w-full max-w-md px-4 py-8 sm:px-8">
        <Outlet />
      </div>
    </div>
  );
}
